import styles from './MenuLink.module.sass'
import Arrow_SVG from "@/components/svg/Global/Arrow_SVG";
import cn from "classnames";
import {useGameContext} from "@/context/GameContext";
import {usePathname} from 'next/navigation'
import {useRouter} from 'next/navigation'


const MenuLink = ({href = null, text="", className, arrowColor = '#EEEECE', setIsMenuOpen = null, ...props}) => {
	const {setIsPlaying, setIsMenuScrolling} = useGameContext()
	const pathName = usePathname()
	const router = useRouter()

	return (
			<div className={cn(styles.link, className, 'custom_pointer')} onClick={() => {
				/* If not home page */
				if(pathName !== '/') {
					router.push('/')
					return
				}

				if(setIsMenuOpen !== null) setIsMenuOpen(false)
				setIsMenuScrolling(true)
				setIsPlaying(true)
				if(href !== null) lenis.scrollTo(href, {lock: true, onComplete: () => {
						setIsMenuScrolling(false)
				}})
			}} {...props}>
				{/*Arrow*/}
				<Arrow_SVG color={arrowColor} className={styles.arrow}/>
				{/*Text*/}
				<span className={styles.text}>{text}</span>
			</div>
	)
}
export default MenuLink
